import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './hoc/Layout';
import Auth from "./pages/Auth/Auth";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import PrivateRoute from "./pages/PrivateRoute/PrivateRoute";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";

const drawerWidth = 240;

function App() {

  const greaterThan768 = useMediaQuery("(min-width:768px)");
  const greaterthan375 = useMediaQuery("(min-width:376px)");



  const [responsiveData, setResponsiveData] = useState({
    iconFontSize: 40,
    responsiveDrawerWidth: drawerWidth,
    fontSize: '1.5rem',
    imageWidth: '4rem',
    paperWidth: '10rem',
    paperHeight: '10rem'
  })

  useEffect(() => {
    if (!greaterthan375) {
      setResponsiveData({
        responsiveDrawerWidth: '100%',
        iconFontSize: 25,
        fontSize: '1.1rem',
        imageWidth: '3rem',
        paperWidth: '80vw',
        paperHeight: '40rem',
        formWidth: '80%',
        buttonSize: 'small'
      });
    } else if (greaterthan375 && !greaterThan768) {
      setResponsiveData({
        responsiveDrawerWidth: '100%',
        fontSize: '1.3rem',
        imageWidth: '3.5rem',
        iconFontSize: 30,
        paperWidth: '60vw',
        formWidth: '80%',
        paperHeight: '45rem',
        buttonSize: 'medium'

      })
    } else if (greaterThan768) {
      setResponsiveData({
        responsiveDrawerWidth: drawerWidth,
        fontSize: '1.5rem',
        imageWidth: '4rem',
        iconFontSize: 40,
        paperWidth: '40vw',
        paperHeight: '45rem',
        formWidth: '60%',
        buttonSize: 'large'
      })
    }

  }, [greaterthan375, greaterThan768])

  const breakPointsData = { greaterThan768, greaterthan375, responsiveData };

  return (
    <div >
      <BrowserRouter>
        <Layout breakPointsData={breakPointsData}>

          <Routes>
            <Route path="/ResetPassword/:guid" element={<ResetPassword breakPointsData={breakPointsData} />} />
            <Route exact path="/" element={<Auth breakPointsData={breakPointsData} />} />
            <Route path="*" element={<PageNotFound breakPointsData={breakPointsData} />} />
          </Routes>
        </Layout>
      </BrowserRouter>

    </div>
  );
}

export default App;
